import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

import * as Composition from "./composition";

const applyHighlight = (words: Array<string>, text: string): string => {
	const matchedWord = words.find((word) => text.includes(word));
	if (!matchedWord) return text;

	// マッチした単語にハイライトを適用
	return Composition.Converter.matchedWordToHighlightConverter(matchedWord, text);
};

/**
 *
 * @param words {Array<string>} - 検索単語
 * @param searchContents {Array<SearchContent>} - 検索コンテンツ
 *
 * @returns {Array<SearchContent>} - ハイライトを適用した検索コンテンツ
 */
export const highlightMapper = (words: Array<string>, searchContents: SearchedContent): SearchedContent => {
	if (words.length === 0) return searchContents;

	return searchContents.map((content) => ({
		...content,
		...content,
		categoryText: applyHighlight(words, content.categoryText),
		subcategories: content.subcategories.map((subcategory) => ({
			...subcategory,
			text: applyHighlight(words, subcategory.key),
			contents: subcategory.contents.map((content) => ({
				...content,
				text: applyHighlight(words, content.text),
			})),
		})),
	}));
};
